import { useEffect } from 'react';

export const useScrollLock = (lock: boolean) => {
  useEffect(() => {
    const body = document.body;
    if (lock) {
      body.classList.add('scroll-lock');
    } else {
      body.classList.remove('scroll-lock');
    }
    return () => {
      body.classList.remove('scroll-lock');
    };
  }, [lock]);
};
